import React, { FC, useCallback } from 'react';
import { Button, Col, ModalBody, ModalFooter, Row } from 'reactstrap';
import { Breadcrumb } from '../../../../components';
import { MaterialIconText } from '../../../../components/MaterialIconText';
import { useTranslation } from '../../../../translations';
import { emptyFallback } from '../../../../utils';
import { RaffleConfiguratorProps } from '../utils';

export const RandomNumber: FC<RaffleConfiguratorProps> = ({
  displayName,
  onBack,
  onCancel,
  onConfigure,
}) => {
  const { ts } = useTranslation();
  const onFinish = useCallback(() => {
    onConfigure({ name: 'cryptoRandom' });
  }, [onConfigure]);

  return (
    <>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Breadcrumb
              items={[
                { text: `${ts('common.display_name')}: ${emptyFallback(displayName, 'None')}` },
                { text: `${ts('type')}: Random Number` },
              ]}
            />
            <MaterialIconText name="keyboard_backspace" onClick={onBack}>
              {ts('common.go_back')}
            </MaterialIconText>
            <hr />
          </Col>
          <Col xs={12}>
            <p>
              <i>{ts('there_are_no_configuration_options_for_this_component')}</i>
            </p>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button className="editor-finish-btn" color="primary" onClick={onFinish}>
          {ts('common.finish')}
        </Button>
        <Button className="editor-cancel-btn" color="secondary" onClick={onCancel} outline>
          {ts('common.cancel')}
        </Button>
      </ModalFooter>
    </>
  );
};
